import { render, staticRenderFns } from "./vcSelectProject.vue?vue&type=template&id=a051bac6&"
import script from "./vcSelectProject.vue?vue&type=script&lang=js&"
export * from "./vcSelectProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports